import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tyt-full-episode-tag',
  templateUrl: './full-episode-tag.component.html',
  styleUrls: ['./full-episode-tag.component.scss']
})
export class FullEpisodeTagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
